<div class="sublote-card-v2">
  <div class="sublote-header">
    <div class="sublote-title-row">
      <div class="sublote-name">
        <span class="sublote-marker" [ngClass]="partner.FirstContractIsSubstabelecido ? 'subs' : ''"></span>
        <span class="header-name">{{ beneficiaryName }}</span>
        <span class="sublote-type-tag" [ngClass]="partner.FirstContractIsSubstabelecido ? 'subs' : ''">{{
          beneficiaryTypeLabel }}</span>
        <button *ngIf="partner.EconomicGroupAutorizationFile && !partner.OfficeName && !partner.DocuSignContractId"
          type="button" class="header-edit-btn" (click)="handleBeneficiary()">
          <app-svg-icon src="assets/icons/edit-icon.svg" width="14px" height="14px" color="primary"></app-svg-icon>
        </button>
        <span class="badge" [ngClass]="getHeaderStatusClass()">
          <span class="badge-dot"></span>
          {{ getHeaderStatusLabel() }}
        </span>
      </div>
      <div class="sublote-repasse">
        <span>Valor do Repasse:</span>
        <strong>{{ totalContractsTransferAmount | currency:'BRL' }}</strong>
      </div>
      <span *ngIf="partner.OfficeName" class="header-office-copy">
        Repasse efetuado para:
        <strong>{{ partner.OfficeName }}</strong>
      </span>
    </div>

    <div class="sublote-actions">
      <input #authorizationInput class="hidden-file-input" type="file" accept="application/pdf,.pdf"
        (change)="onSelectFile({ event: $event, fileName: AnnexEnum.AutorizacaoRepasse })">
      <input #secondaryAnnexInput class="hidden-file-input" type="file" accept="application/pdf,.pdf"
        (change)="onSelectFile({ event: $event, fileName: secondaryAnnexTitle })">

      <!-- <button class="action-icon" type="button" matTooltip="Autorização de Repasse" [disabled]="annexList[0].DisableUpload && !annexList[0].AllowDownload" (click)="handleAuthorizationAction(authorizationInput)">
        <app-svg-icon src="assets/icons/download-icon.svg" width="16px" height="16px" color="arrowGray"></app-svg-icon>
      </button> -->

      <button class="action-icon action-icon-annex" type="button" [matTooltip]="'Enviar ' + secondaryAnnexTitle"
        [disabled]="secondaryAnnexDisabled" (click)="handleSecondaryAnnexAction(secondaryAnnexInput)">
        <app-svg-icon src="assets/icons/clip-icon.svg" width="16px" height="16px" color="primary"></app-svg-icon>
      </button>
      <button class="action-text" type="button" [matTooltip]="'Baixar ' + secondaryAnnexTitle"
        [disabled]="!secondaryAnnexAllowDownload" (click)="downloadSecondaryAnnex()">
        <app-svg-icon src="assets/icons/download-icon.svg" width="16px" height="16px" color="arrowGray"></app-svg-icon>
        {{ secondaryAnnexTitle }}
      </button>

      <div class="divider-v"></div>

      <button class="action-icon" type="button" matTooltip="Prévia do e-mail do beneficiário"
        (click)="previewEmailEvent.emit({ paymentEmail: false, partnerId: partner.BatchId.toString() })">
        <app-svg-icon src="assets/icons/view-icon.svg" width="16px" height="16px" color="primary"></app-svg-icon>
      </button>

      <button class="action-icon" type="button" matTooltip="Enviar e-mail por beneficiário" [disabled]="partner.HasRpa"
        (click)="sendEmailEvent.emit({ paymentEmail: false, partnerId: partner.BatchId.toString() })">
        <app-svg-icon src="assets/icons/email-icon.svg" width="16px" height="16px" color="primary"></app-svg-icon>
      </button>

      <button class="action-icon" type="button" matTooltip="Prévia do e-mail de pagamento do beneficiário"
        (click)="previewEmailEvent.emit({ paymentEmail: true, partnerId: partner.BatchId.toString() })">
        <app-svg-icon src="assets/icons/view-icon.svg" width="16px" height="16px" color="primary"></app-svg-icon>
      </button>

      <button class="action-icon" type="button" matTooltip="Enviar e-mail de pagamento por beneficiário"
        [disabled]="!partner.EstimatedPaymentDate"
        (click)="sendEmailEvent.emit({ paymentEmail: true, partnerId: partner.BatchId.toString() })">
        <app-svg-icon src="assets/icons/finance-email.svg" width="16px" height="16px" color="primary"></app-svg-icon>
      </button>

      <div class="divider-v"></div>

      <button class="action-text" type="button" matTooltip="Cancelar Integração OMIE" [disabled]="blockCancel"
        (click)="handleCancelSubBatch()">
        <app-svg-icon src="assets/icons/circle-xmark.svg" width="16px" height="16px" color="dangerRed"></app-svg-icon>
        Cancelar
      </button>

      <!-- <button class="action-icon" type="button" matTooltip="Download do comprovante de pagamento" [disabled]="partner.HasPaymentProof != true" (click)="getPaymentProof()">
        <app-svg-icon src="assets/icons/clip-icon.svg" width="16px" height="16px" color="arrowGray"></app-svg-icon>
      </button> -->

      <!-- <div class="divider-v"></div> -->

      <button class="action-text" type="button" matTooltip="Integração OMIE" [disabled]="!canIntegrateSapPartner"
        (click)="handleIntegrateSapPartner()">
        <app-svg-icon src="assets/icons/reload-icon.svg" width="14px" height="14px" color="arrowGray"></app-svg-icon>
        OMIE
      </button>

      <button class="action-text" type="button" matTooltip="Liberar manualmente este sublote"
        [disabled]="!canLiberarManual" (click)="handleLiberarManual()">
        <app-svg-icon src="assets/icons/check-icon.svg" width="14px" height="14px" color="arrowGray"></app-svg-icon>
        Liberar Manual
      </button>

      <button class="action-text" type="button" *ngIf="showClipboardCopy" (click)="exportToClipboard()"
        matTooltip="Copiar dados">
        Copiar
      </button>
    </div>
  </div>

  <div class="sublote-info-bar">

    <!-- Grupo: Fiscal -->
    <div class="info-group info-group--fiscal">
      <span class="info-group-title">Fiscal</span>
      <div class="info-chip">
        <div class="chip-label">NF</div>
        <div class="chip-value chip-value-inline">
          {{ partner.InvoiceNumber || '—' }}
          <button *ngIf="canEditInvoiceInfo" type="button" class="inline-icon-btn" (click)="handleInvoiceInfo()">
            <app-svg-icon src="assets/icons/edit-icon.svg" width="12px" height="12px" color="primary"></app-svg-icon>
          </button>
        </div>
      </div>
      <div class="info-chip">
        <div class="chip-label">SIMPLES NACIONAL</div>
        <div class="chip-value">{{ simplesNacionalLabel }}</div>
      </div>
      <div class="info-chip">
        <div class="chip-label">SIMEI</div>
        <div class="chip-value">{{ simeiLabel }}</div>
      </div>
      <div class="info-chip info-chip-wide">
        <div class="chip-label">CÓDIGO DE SERVIÇO NF</div>
        <ng-container *ngIf="canEditServiceCode; else serviceCodeReadonly">
          <select class="info-select" aria-label="Código de serviço NF" [formControl]="serviceCodeControl"
            [attr.title]="selectedServiceCodeName" (change)="onServiceCodeChange(serviceCodeControl.value)">
            <option value="">Nenhum</option>
            <option *ngFor="let option of serviceCodeOptions; trackBy: trackByOptionId" [value]="option.id" [title]="option.name">{{ truncateOptionLabel(option.name) }}</option>
          </select>
        </ng-container>
        <ng-template #serviceCodeReadonly>
          <div class="chip-value">{{ serviceCodeLabel }}</div>
        </ng-template>
      </div>
    </div>

    <!-- Grupo: Retenções -->
    <div class="info-group info-group--retencoes" [attr.aria-busy]="recalculating">
      <span class="info-group-title">Retenções</span>
      <div class="info-chip" *ngFor="let chip of retencaoChips">
        <div class="chip-label">{{ chip.label }}</div>
        <ng-container *ngIf="!recalculating; else chipSkeleton">
          <div class="chip-value">{{ chip.amount | currency:'BRL' }}</div>
          <div class="chip-sub">{{ hasRetencaoRate(chip) ? ((chip.rate | number:'1.1-2':'pt-BR') + '%') : '—' }}</div>
        </ng-container>
      </div>
      <div class="info-net-row">
        <div class="info-chip">
          <div class="chip-label chip-label-nowrap">VALOR LÍQUIDO</div>
          <div class="chip-value chip-value-net" *ngIf="!recalculating; else netSkeleton">{{ netValue | currency:'BRL' }}</div>
        </div>
        <span class="status-pill pill-neutral" *ngIf="isRetencaoIsenta">{{ retencaoIsencaoLabel }}</span>
      </div>
      <ng-template #chipSkeleton>
        <div class="chip-skeleton chip-skeleton--value" role="status" aria-label="Calculando"></div>
        <div class="chip-skeleton chip-skeleton--sub"></div>
      </ng-template>
      <ng-template #netSkeleton>
        <div class="chip-skeleton chip-skeleton--net" role="status" aria-label="Calculando"></div>
      </ng-template>
    </div>

    <!-- Grupo: Pagamento -->
    <div class="info-group info-group--pagamento">
      <span class="info-group-title">Pagamento</span>
      <div class="info-chip">
        <div class="chip-label">DT. PREV. PAGAMENTO</div>
        <ng-container *ngIf="!canEditPaymentDate; else paymentDateEditor">
          <div class="chip-value">{{ partner.EstimatedPaymentDate ? (partner.EstimatedPaymentDate | date:'dd/MM/yyyy') :
            '—' }}</div>
        </ng-container>
        <ng-template #paymentDateEditor>
          <div class="info-date-editor">
            <input class="info-date-input" type="date" [formControl]="paymentDate">
            <button type="button" class="inline-icon-btn" [disabled]="paymentDate.invalid"
              (click)="handlePaymentDate()">
              <app-svg-icon src="assets/icons/save-icon.svg" width="12px" height="12px"
                color="lightGray"></app-svg-icon>
            </button>
          </div>
        </ng-template>
      </div>
      <div class="info-chip">
        <div class="chip-label">DATA DE INTEGRAÇÃO</div>
        <div class="chip-value">{{ partner.IntegrationDate ? (partner.IntegrationDate | date:'dd/MM/yyyy') : '—' }}
        </div>
      </div>
      <div class="info-chip">
        <div class="chip-label">STATUS DE PAGAMENTO</div>
        <div class="chip-value">
          <span class="status-pill" [ngClass]="partner.PaymentDate ? 'pill-success' : 'pill-warn'">{{
            partner.PaymentDate ? 'Pago' : 'Pendente' }}</span>
        </div>
      </div>
      <div class="info-chip">
        <div class="chip-label">DATA DE PAGAMENTO</div>
        <div class="chip-value">{{ partner.PaymentDate ? (partner.PaymentDate | date:'dd/MM/yyyy') : '—' }}</div>
      </div>
      <div class="info-chip" *ngIf="partner.CancelamentoSapCode">
        <div class="chip-label">DATA CANCELAMENTO</div>
        <div class="chip-value">
          <span *ngIf="loadingCancelamentoStatus">Consultando...</span>
          <span *ngIf="!loadingCancelamentoStatus">{{ dataCancelamentoProcessado ? (dataCancelamentoProcessado | date:'dd/MM/yyyy HH:mm') : 'Aguardando confirmação do OMIE' }}</span>
        </div>
      </div>
    </div>

    <!-- Grupo: Integração OMIE -->
    <div class="info-group info-group--integracao">
      <span class="info-group-title">Integração</span>
      <div class="info-chip">
        <div class="chip-label">Nº PEDIDO OMIE</div>
        <div class="chip-value">{{ partner.OrderNumber || '—' }}</div>
      </div>
      <div class="info-chip">
        <div class="chip-label">STATUS PEDIDO OMIE</div>
        <div class="chip-value chip-value-inline">
          {{ partner.IntegrationError ? 'Não processado' : (partner.SapPaymentStatus || '—') }}
          <button *ngIf="showIntegrationErrorButton" type="button" class="inline-icon-btn"
            (click)="showIntegrationErrorMessage()">
            <app-svg-icon src="assets/icons/message-icon.svg" width="12px" height="12px"
              color="arrowGray"></app-svg-icon>
          </button>
        </div>
      </div>
      <div class="info-chip">
        <div class="chip-label">SUBLOTE</div>
        <div class="chip-value">{{ partner.BatchNumber || '—' }}</div>
      </div>
    </div>

    <!-- Grupo: Especial (condicional) -->
    <div class="info-group info-group--special"
      *ngIf="partner.HasOffice || partner.HasEconomicGroup || (partner.Reverses && partner.Reverses.length > 0)">
      <span class="info-group-title">Especial</span>
      <ng-container *ngIf="partner.HasOffice">
        <div class="info-chip">
          <div class="chip-label">TIPO</div>
          <div class="chip-value">Pagadoria</div>
        </div>
        <div class="info-chip">
          <div class="chip-label">BENEFICIÁRIO</div>
          <div class="chip-value">{{ partner.OfficeName || '—' }}</div>
        </div>
        <div class="info-chip">
          <div class="chip-label">CPF/CNPJ BENEFICIÁRIO</div>
          <div class="chip-value">{{ partner.OfficeDocument || '—' }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="partner.HasEconomicGroup">
        <div class="info-chip">
          <div class="chip-label">TIPO</div>
          <div class="chip-value">Grupo Econômico</div>
        </div>
      </ng-container>
      <ng-container *ngIf="partner.Reverses && partner.Reverses.length > 0">
        <div class="info-chip">
          <div class="chip-label">VALOR DE ESTORNO</div>
          <div class="chip-value">{{ (partner.TotalReversedNegativo | currency:'BRL') || '—' }}</div>
        </div>
        <div class="info-chip">
          <div class="chip-label">SALDO DE ESTORNO</div>
          <div class="chip-value">{{ (partner.ReverseBalance | currency:'BRL') || '—' }}</div>
        </div>
      </ng-container>
    </div>

  </div>

  <div class="contracts-grid" *ngIf="contracts.length">
    <div class="contracts-grid__header">
      <span>Contrato</span>
      <span>Consulta</span>
      <span>Data Prod.</span>
      <span>Cliente</span>
      <span>Banco / Operação / Produto</span>
      <span>Lote Fat.</span>
      <span>Valor Fin.</span>
      <span>Status</span>
      <span>Valor Repasse</span>
      <span>Ações</span>
    </div>

    <ng-container *ngFor="let contract of contracts">
      <div class="contracts-grid__row">
        <div class="contracts-grid__contract">
          <span class="contract-status-dot" [ngClass]="contract.Active ? 'active' : 'inactive'"></span>
          <span class="contracts-grid__contract-label">
            {{ contract.Number }}
            <span *ngIf="contract.Version" class="contract-version-badge">v{{ contract.Version }}</span>
          </span>
        </div>

        <span class="contracts-grid__cell">{{ contract.QueryNumber || '-' }}</span>
        <span class="contracts-grid__cell">{{ contract.ProductionDate ? (contract.ProductionDate | date:'dd/MM/yyyy') :
          '-' }}</span>
        <div class="contracts-grid__cell contracts-grid__cell--stack"
          [matTooltip]="(contract.Client || '-') + ' · ' + (contract.ClientDocument || '-')">
          <span class="contracts-grid__primary">{{ contract.Client || '-' }}</span>
          <span class="contracts-grid__secondary">{{ contract.ClientDocument || '-' }}</span>
        </div>

        <div class="contracts-grid__cell contracts-grid__cell--stack"
          [matTooltip]="((contract.FinancialInstitution | titlecase) || '-') + ' · ' + (contract.OperationType || '-') + ' · ' + getContractProductLabel(contract)">
          <span class="contracts-grid__primary">{{ (contract.FinancialInstitution | titlecase) || '-' }} · {{
            contract.OperationType || '-' }}</span>
          <span class="contracts-grid__secondary">Prod: {{ getContractProductLabel(contract) }}</span>
        </div>
        <span class="contracts-grid__cell">{{ contract.InvoiceBatchNumber || '-' }}</span>
        <span class="contracts-grid__cell">{{ contract.Amount ? (contract.Amount | currency:'BRL') : '-' }}</span>

        <span class="contract-meta">{{ contract.Status || '-'
          }}</span>

        <span class="contract-amount"
          [class.negative]="(contract.TransferAmountNegativo || contract.TransferAmount || 0) < 0">
          {{ (contract.TransferAmountNegativo || contract.TransferAmount || 0) | currency:'BRL' }}
        </span>

        <div class="contracts-grid__actions">

          <button class="btn-view" (click)="openModalDetails(contract.Number)">
            <app-svg-icon src="assets/icons/view-icon.svg" width="16px" height="16px"></app-svg-icon>
          </button>

          <button class="btn-delete" [class.selected]="isContractSelectedForDelete(contract.ContractId)"
            *ngIf="!subBatchBlocked && !isContractBlockedByIntegratedSubestabelecido(contract)" (click)="deleteContractEvent.emit({
                      contractId: contract.ContractId,
                      isDelete: !isContractSelectedForDelete(contract.ContractId)
                    })">
            <app-svg-icon src="assets/icons/trash-icon.svg" width="14px" height="14px"></app-svg-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="contracts-stack contracts-stack--mobile">
    <ng-container *ngFor="let contract of contracts">
      <div class="contract-card">
        <div class="contract-head">
          <div class="contract-main">
            <span class="contract-status-dot" [ngClass]="contract.Active ? 'active' : 'inactive'"></span>
            <div class="contract-titles">
              <span class="contract-number">
                Contrato {{ contract.Number }}
                <span *ngIf="contract.Version" class="contract-version-badge">v{{ contract.Version }}</span>
                <span class="contract-meta-sep" aria-hidden="true">·</span>
                <span class="contract-meta">Consulta {{ contract.QueryNumber }}</span>
                <span class="contract-meta-sep" aria-hidden="true">·</span>
                <span class="contract-meta">Data Prod. {{ contract.ProductionDate | date:'dd/MM/yyyy' }}</span>
              </span>
            </div>
          </div>
          <div class="contract-head-right">
            <span class="contract-badge" [ngClass]="getContractStatusClass(contract.Status)">{{ contract.Status
              }}</span>
            <span class="contract-amount"
              [class.negative]="(contract.TransferAmountNegativo || contract.TransferAmount || 0) < 0">
              {{ (contract.TransferAmountNegativo || contract.TransferAmount || 0) | currency:'BRL' }}
            </span>

            <button class="btn-view" (click)="openModalDetails(contract.Number)">
              <app-svg-icon src="assets/icons/view-icon.svg" width="16px" height="16px" color="white"></app-svg-icon>
            </button>

            <button class="btn-delete" [class.selected]="isContractSelectedForDelete(contract.ContractId)"
              *ngIf="!subBatchBlocked && !isContractBlockedByIntegratedSubestabelecido(contract)" (click)="deleteContractEvent.emit({
                        contractId: contract.ContractId,
                        isDelete: !isContractSelectedForDelete(contract.ContractId)
                      })">
              <app-svg-icon src="assets/icons/trash-icon.svg" width="14px" height="14px"></app-svg-icon>
            </button>
          </div>
        </div>

        <div class="contract-details">
          <div class="detail-group">
            <span class="detail-primary">{{ contract.Client }}</span>
            <span class="detail-muted">{{ contract.ClientDocument }}</span>
          </div>
          <div class="detail-group">
            <span class="detail-primary">{{ contract.FinancialInstitution | titlecase }}</span>
            <span class="detail-muted">{{ contract.OperationType }} · {{ contract.Chanel }}</span>
          </div>
          <div class="detail-group detail-group--end">
            <span class="detail-primary">Lote Fat. {{ contract.InvoiceBatchNumber }}</span>
            <span class="detail-muted">Valor Fin. {{ contract.Amount | currency:'BRL' }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

</div>